import {HOUSE_ACTIONS} from "../actions/types";
import {updateCache} from "ith-redux-helpers";
import {uniqify} from "ah-lib";
import isArray from 'lodash/isArray';

const defaultState = {
	list: []
};

export default (state = defaultState, {type, list, house, house_id, count, id, module_id, replace = false}) => {
	switch (type) {
		case HOUSE_ACTIONS.LOAD_ALL:
			return {list, ...updateCache()};
		case HOUSE_ACTIONS.LOAD_ONE:
			list = state.list;
			if ( list.find(h => h.house_id === house.house_id)) {
				list = list.map(h => h.house_id === house.house_id ? house : h);
			} else {
				list = [...list, house];
			}
			return {list, ...updateCache()};
		case HOUSE_ACTIONS.REMOVE_ONE:
			return {
				list: state.list.filter(house => house.house_id !== id),
				...updateCache()
			};
		case HOUSE_ACTIONS.ASSIGN_MODULES:
			return {
				...state,
				list: state.list.map(h => {
					if ( h.house_id === id ) {
						h.modules = uniqify(h.modules, list)(m => m.module_id);
					}
					return {...h};
				})
			};
		case HOUSE_ACTIONS.REVOKE_MODULES:
			return {
				...state,
				list: state.list.map(h => {
					if ( h.house_id === id) {
						h.modules = h.modules.filter(m => m.module_id !== module_id);
					}
					return {...h};
				})
			};
		case HOUSE_ACTIONS.SET_KFZ:
			return {
				...state,
				list: state.list.map(h => {
					if (h.house_id === id) {
						h = {
							...h,
							kfz: replace ? list : (isArray(h.kfz) ? uniqify(h.kfz, list)(car => car.kfz_id) : list)
						}
					}
					return h;
				})
			};
		case HOUSE_ACTIONS.REMOVE_LOGO:
			return {
				...state,
				list: state.list.map(h => {
					if ( h.house_id === id ) {
						h = {
							...h,
							logo: null,
							logo_id: null
						}
					}
					return h;
				})
			};
		case HOUSE_ACTIONS.GET_ACTIVE_WORKERS:
			return {
				...state,
				list: state.list.map(h => {
					if (h.house_id === house_id) {
						return {
							...h,
							active_workers: count
						};
					}
					return h;
				})
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/houseReducer.js